<template>
  <div>
    <div class="manage">
      <div class="manage_title">交易模式设置</div>
      <div>
        <el-checkbox
          v-model="checked"
          label="0"
          disabled
          style="color: #333333"
        >
          支持先款后货
        </el-checkbox>
        <el-checkbox v-model="param.data" true-label="31" @change="changeBox">
          支持先货后款
          <span v-if="param.data == 31">
            <el-button
              type="text"
              style="margin-left: 5px"
              @click="handleCompanyScope"
            >
              [设置先货后款企业范围]
            </el-button>
          </span>
        </el-checkbox>
      </div>
    </div>
    <div class="manage">
      <div class="manage_title">开票方式设置</div>
      <el-checkbox-group v-model="checkList" @change="updateInvoice">
        <el-checkbox :label="1"
          >不支持开具运费发票,需将运费并入商品价格中</el-checkbox
        >
        <el-checkbox :label="2">可独立开具运费发票</el-checkbox>
      </el-checkbox-group>
    </div>
    <div v-show="isOpenEInvoice" class="manage">
      <div class="manage_title">电子发票服务</div>
      <div class="switch-block">
        <span>启用电子发票</span>
        <span class="switch">
          <el-switch
            v-model="electronicInvoiceSwitch"
            active-value="121"
            inactive-value="122"
            @change="changeElectronicInvoice"
          >
          </el-switch>
        </span>
        <span style="margin-left: 20px">
          <el-popover
            placement="top-start"
            width="200"
            trigger="hover"
            content="您已开通电子发票服务，可将开票信息一键推送至百望平台，在百望平台集中进行开票管理。关闭后，客户下新订单时无法选择开具电子发票；已选择电子发票的历史订单仍需按已约定的电子发票形式进行开具。"
          >
            <i slot="reference" class="header-icon el-icon-question"></i>
          </el-popover>
        </span>
      </div>
    </div>
    <div v-if="whiteListFlag" class="manage">
      <div class="manage_title">支付方式设置</div>
      <div class="show-flex">
        <span class="manage_title">线上支付：</span>
        <el-checkbox-group
          v-model="paymentMethodList"
          @change="addPaymentConfig"
        >
          <el-checkbox :label="0" :disabled="handleDisabled(0)"
            >直接支付</el-checkbox
          >
          <el-checkbox :label="1" :disabled="handleDisabled(1)"
            >担保支付</el-checkbox
          >
          <el-checkbox :label="3" :disabled="handleDisabled(3)"
            >网银支付</el-checkbox
          >
          <el-checkbox :label="4" :disabled="handleDisabled(4)"
            >扫码支付</el-checkbox
          >
        </el-checkbox-group>
      </div>
      <div class="show-flex">
        <span class="manage_title">线下支付：</span>
        <el-checkbox-group
          v-model="paymentMethodList"
          @change="addPaymentConfig"
        >
          <el-checkbox
            :label="103"
            :disabled="handleDisabled(103)"
            style="margin-right: 58px"
          >
            现金
          </el-checkbox>
          <el-checkbox :label="101" :disabled="handleDisabled(101)"
            >网银转账</el-checkbox
          >
          <el-checkbox :label="102" :disabled="handleDisabled(102)"
            >承兑汇票</el-checkbox
          >
          <el-checkbox :label="104" :disabled="handleDisabled(104)"
            >支票</el-checkbox
          >
        </el-checkbox-group>
      </div>
    </div>
    <div class="container">
      <div class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>
            <i class="el-icon-lx-cascades"></i>
            支持售后类型设置
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-checkbox-group
        v-model="afterSalesTypeList"
        @change="updateAfterSales"
      >
        <el-checkbox :label="1" :disabled="true">退款</el-checkbox>
        <el-checkbox :label="2" :disabled="true">退货</el-checkbox>
        <el-checkbox :label="3">换货</el-checkbox>
        <el-checkbox :label="4">维修</el-checkbox>
        <el-checkbox :label="5">补货</el-checkbox>
      </el-checkbox-group>
    </div>

    <div class="manage">
      <div class="manage_title">设置采购商品范围</div>
      <div>
        <el-radio-group
          v-model="radio"
          @change="updateDefaultPurchaseProductSet"
        >
          <el-radio label="62">仅协议商品</el-radio>
          <el-radio label="61">平台所有商品</el-radio>
        </el-radio-group>

        <div class="yellow-tip">
          注：对于计划外采购行为（即不通过采购申请下单的采购计划），控制采购的范围是否仅限框架协议商品
        </div>
      </div>
    </div>
    <div v-if="planIsOpen" class="manage">
      <div class="manage_title">非计划采购参数设置</div>
      <div>
        <el-radio-group v-model="planRadio" @change="planChange">
          <el-radio label="81">
            开启非计划采购
            <el-button
              type="text"
              style="margin-left: 5px"
              @click="openCategoryDialog"
            >
              [配置可采商品分类]已选{{ defaultChecked.length }}分类
            </el-button>
          </el-radio>
          <el-radio label="82">关闭非计划采购</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="manage">
      <div class="manage_title">取消订单范围权限设置</div>
      <div>
        <el-radio-group v-model="cancleFlag" @change="saveOrderCancelConfig">
          <el-radio label="113">仅下单人订单</el-radio>
          <el-radio label="114">所有订单</el-radio>
        </el-radio-group>
        <div class="yellow-tip">注：管理员可取消所有订单</div>
      </div>
    </div>

    <AddCompanyScope
      ref="addDialog"
      :title="title"
      :form="form"
      :visible="dialogVisible"
      @cancel="handleCancel"
      @save="saveEdit"
      @open="openDialog"
    />
    <el-dialog
      title="添加企业"
      :visible.sync="addVisible"
      width="60%"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div class="query-box">
        <div style="display: flex; align-items: center; margin-left: 60px">
          <span style="margin-right: 10px">企业名称:</span>
          <el-input
            v-model="enterpriseName"
            placeholder="请输入企业名称"
            size="mini"
            style="width: 220px"
          />
        </div>
        <div style="text-align: center; margin: 20px 0">
          <el-button class="btn" @click="reset">重置</el-button>
          <el-button class="btn search" @click="search">查询</el-button>
        </div>
      </div>
      <el-table :data="addTableData" border>
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column
          v-for="column in addTableColumns"
          :key="column.prop"
          :prop="column.prop"
          :label="column.label"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="addScope(scope.row)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="queryPur.pageNum"
          :page-sizes="[10, 20, 50]"
          :page-size="queryPur.pageSize"
          prev-text="上一页"
          next-text="下一页"
          :total="addPageTotal"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        ></el-pagination>
      </div>
    </el-dialog>

    <el-dialog
      title="配置可采商品分类"
      :visible.sync="categoryVisible"
      width="800px"
      :append-to-body="true"
    >
      <div class="category-management">
        <div class="left-tree tree-item">
          <div class="title">平台后台类目</div>
          <div class="search">
            <el-input
              v-model="searchLeftValue"
              size="small"
              suffix-icon="el-input__icon el-icon-search"
              class="search-input"
              placeholder="搜索分类"
              @keyup.enter.native="handleLeftTreeValue"
            ></el-input>
          </div>
          <div class="tree scrollbar-none">
            <el-tree
              ref="leftTree"
              v-loading="treelLoading"
              :data="leftTreeData"
              show-checkbox
              node-key="categoryId"
              :default-expanded-keys="defaultChecked"
              :default-checked-keys="defaultChecked"
              :filter-node-method="fliterLeftTree"
              :props="defaultProps"
            ></el-tree>
          </div>
        </div>
        <div class="btn-options">
          <div class="button-div">
            <div>
              <el-button type="primary" class="btn" @click="handleAdd"
                >添加 》</el-button
              >
            </div>
            <div>
              <el-button type="primary" class="btn move" @click="handleRemove"
                >《 移除</el-button
              >
            </div>
          </div>
        </div>
        <div class="right-tree tree-item">
          <div class="title">已选类目</div>
          <div class="search">
            <el-input
              v-model="searchRightValue"
              size="small"
              suffix-icon="el-input__icon el-icon-search"
              class="search-input"
              placeholder="搜索分类"
              @keyup.enter.native="handleRightTreeValue"
            ></el-input>
          </div>
          <div class="tree scrollbar-none">
            <el-tree
              ref="rightTree"
              v-loading="treelLoading"
              :data="rightTreeData"
              show-checkbox
              :filter-node-method="fliterRightTree"
              node-key="categoryId"
              :props="defaultPropsTree"
            ></el-tree>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCategoryCancel">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import invoiceApi from '@/modules/projectA/api/electronicInvoice';
import api from '../../api/company';
import userApi from '../../api/user';
import productApi from '../../api/product/index';
import AddCompanyScope from './addCompanyScope';
// import eSearch from "../../components/common/e-search";
export default {
  name: 'TransactionModeManage',
  components: {
    AddCompanyScope,
    // eSearch
  },
  data() {
    return {
      disabledFlag: false,
      value: '',
      companyName: '',
      param: {
        data: '',
      },
      checked: true,
      dialogVisible: false,
      form: {},
      title: '先货后款企业',
      paymentMethodList: [], // 支付方式设置
      accountStatus: true,
      whiteListFlag: false, // 白名单
      checkList: [],
      afterSalesTypeList: [1, 2],
      addVisible: false,
      addPageTotal: 0,
      addTableData: [],
      queryPur: {
        companyName: '',
        companyId: '',
        pageNum: 1,
        pageSize: 10,
      },
      addFieldList: [
        {
          label: '企业名称',
          type: 'input',
          value: 'companyName',
        },
      ],
      addColumns: [
        {
          prop: 'buyerCompanyName',
          label: '企业名称',
          show: true,
        },
      ],
      newSearchObject: {
        companyName: '',
        pageNum: 1,
        pageSize: 10,
      },
      oldCompanyName: '',
      enterpriseName: '',
      cancleFlag: '114', // 取消权限
      radio: '61',
      planRadio: '',
      searchLeftValue: '',
      leftTreeData: [],
      defaultChecked: [],
      defaultProps: {
        label: 'categoryName',
        children: 'children',
      },
      defaultPropsTree: {
        label: 'categoryName',
        children: 'children',
        // disabled: function (data, node) {
        // 	console.log(node)
        // 	return data.shareAgreement
        // }
      },
      rightTreeData: [],
      searchRightValue: '',
      categoryVisible: false,
      selectedCategory: [],
      planIsOpen: false, // 公司是否开启了采购申请
      treelLoading: false,
      electronicInvoiceSwitch: '',
      isOpenEInvoice: false,
      companyInvoiceInfo: {},
    };
  },
  computed: {
    addTableColumns() {
      return this.addColumns.filter((column) => column.show);
    },
    userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  mounted() {
    this.batchJudgeOnlinePayment();
    this.getData();
    this.getDefaultPurchaseProductSet();
    this.queryPurchaseCategory();
    this.queryIsOpen();
    this.queryAfterSalesType();
    this.queryOwnPaymentConfig();
    this.queryOrderCancelConfig(); // 订单取消配置项  查询
    this.getElectronicInvoiceSwitch();
    this.getInvoiceInfo();
  },
  methods: {
    // 订单取消配置项  查询
    // 113:仅下单人可以取消;
    // 114：所有订单
    async queryOrderCancelConfig() {
      await userApi.queryOrderCancelConfig().then((res) => {
        if (res.success) {
          const configData = Object.keys(res.data);
          if (configData.length > 0) {
            this.cancleFlag = res.data.data;
          }
        }
      });
    },
    // 取消订单范围权限设置  cancleFlag
    async saveOrderCancelConfig() {
      await userApi
        .saveOrderCancelConfig({ data: this.cancleFlag })
        .then((res) => {
          if (res.success) {
            this.$message.success('取消订单范围权限设置成功！');
          }
        });
    },
    handleDisabled(val) {
      const arr = [0, 1, 3, 4];
      if (!this.accountStatus && arr.includes(val)) {
        return true;
      }
      if (this.disabledFlag && this.paymentMethodList[0] === val) {
        return true;
      }
      return false;
    },
    // 判断供应商是否开通 在线支付
    async batchJudgeOnlinePayment() {
      const userInfo = JSON.parse(localStorage.getItem('USERINFO'));
      await userApi
        .batchJudgeOnlinePayment({ companyIdList: [userInfo.companyId] })
        .then((res) => {
          this.accountStatus = !!res.data[0].accountStatus;
        });
    },
    // 查询支付方式配置
    async queryOwnPaymentConfig() {
      await userApi.queryOwnPaymentConfig().then((res) => {
        if (res.success) {
          this.whiteListFlag = res.data.whiteListFlag;
          if (res.data.companyConfigList.length === 0) {
            if (this.accountStatus) {
              this.paymentMethodList = [0, 1, 3, 4, 101, 102, 103, 104];
            } else {
              this.paymentMethodList = [101, 102, 103, 104];
            }
          } else {
            this.paymentMethodList = res.data.companyConfigList.map((item) =>
              Number(item.data)
            );
          }
        }
      });

      if (this.paymentMethodList.length === 1) {
        this.disabledFlag = true;
      }
    },
    // 新增支付方式配置
    addPaymentConfig() {
      userApi
        .addPaymentConfig({ dataList: this.paymentMethodList })
        .then((res) => {
          if (res.success) {
            this.$message.success('支付方式修改成功');
          }
        });

      if (this.paymentMethodList.length === 1) {
        this.disabledFlag = true;
      } else if (this.paymentMethodList.length > 1) {
        this.disabledFlag = false;
      }
    },
    // 查询售后类型
    queryAfterSalesType() {
      api.queryAfterSalesType().then((res) => {
        if (res.data.afterSalesTypeList) {
          res.data.afterSalesTypeList.forEach((item) => {
            this.afterSalesTypeList.push(Number(item));
          });
        } else {
          this.afterSalesTypeList = [1, 2, 3, 4, 5];
        }
      });
    },
    // 更改售后
    updateAfterSales() {
      api
        .saveAfterSalesType({ afterSalesTypeList: this.afterSalesTypeList })
        .then((res) => {
          if (res.success) {
            this.$message.success('支持售后类型修改成功');
          }
        });
    },
    clear() {
      this.enterpriseName = '';
      this.companyName = '';
      this.queryPur.companyName = '';
    },
    closeDialog() {
      api
        .companyRelationPage({
          companyName: '不可能搜索到的字符串',
          pageNum: this.queryPur.pageNum,
          pageSize: this.queryPur.pageSize,
        })
        .then((res) => {
          if (res.code == 200) {
            this.addTableData = res.data.records;
            this.addPageTotal = res.data.total;
          }
        });
      this.enterpriseName = '';
    },
    handleCompanyScope() {
      this.form = {};
      this.title = '先货后款企业';
      this.dialogVisible = true;
    },
    handleCancel() {
      this.dialogVisible = false;
    },
    saveEdit() {
      this.dialogVisible = false;
    },
    getData() {
      api.queryCompanyPayType().then((res) => {
        if (res.success) {
          this.param.data = res.data.data.toString();
        }
      });
      api.queryByCompanyId().then((res) => {
        if (res.code == 200 && res.data) {
          if (res.data.invoiceModeCode === 3) {
            this.checkList.push(1);
            this.checkList.push(2);
          } else {
            this.checkList.push(res.data.invoiceModeCode);
          }
        }
      });
    },
    changeBox(val) {
      if (val != 31) {
        this.$confirm(
          '取消选中将清空您设置的企业范围,再次选中时需重新设置,是否取消选中?',
          '提示',
          {
            confirmButtonText: '确 定',
            cancelButtonText: '取 消',
            type: 'warning',
          }
        )
          .then(() => {
            api
              .deletePayType({
                companyId: 1234,
              })
              .then((res) => {
                if (res.code === '200') {
                  this.$message({
                    type: 'success',
                    message: '删除成功!',
                  });
                } else {
                  this.$message({
                    type: 'info',
                    message: '已取消删除',
                  });
                }
              });
          })
          .catch(() => {
            this.param.data = '31';
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      } else {
        const param = {};
        param.companyId = 1234;
        param.data = '31';
        api.insertPayType(param).then((res) => {
          if (res.code === '200') {
            this.$message({
              type: 'success',
              message: '新增成功!',
            });
          } else {
            this.$message({
              type: 'info',
              message: '新增失败',
            });
          }
        });
      }
    },
    search() {
      if (this.enterpriseName === '') {
        return this.$message.info('请输入企业名称');
      }

      api
        .companyRelationPage({
          companyName: this.enterpriseName,
        })
        .then((res) => {
          if (res.code == 200) {
            this.addTableData = res.data.records;
            this.addPageTotal = res.data.total;
          }
        });
    },
    reset() {
      this.enterpriseName = '';
    },
    //	添加的分页
    handleCurrentChange(val) {
      api
        .companyRelationPage({
          companyName: this.enterpriseName,
          pageNum: val,
        })
        .then((res) => {
          if (res.code == 200) {
            this.addTableData = res.data.records;
            this.addPageTotal = res.data.total;
          }
        });
    },
    handleSizeChange(val) {
      // 分页的
      // this.newSearchObject.pageSize = val;
      // this.getList()
      if (this.enterpriseName == '') {
        this.$message.info('请输入企业名称');
        return;
      }
      api
        .companyRelationPage({
          companyName: this.enterpriseName,
          pageSize: val,
          pageNum: 1,
        })
        .then((res) => {
          if (res.code == 200) {
            this.addTableData = res.data.records;
            this.addPageTotal = res.data.total;
          }
        });
    },
    handleAddSearch(val) {
      if (val.companyName == '') {
        this.$message.info('请输入企业名称');
        return;
      }
      this.newSearchObject = val;
      this.oldCompanyName = val.companyName;
      this.getList(this.newSearchObject);
    },
    getList(val) {
      if (val.companyName == '') {
        this.$message.info('请输入企业名称');
        return;
      }
      api.companyRelationPage(val).then((res) => {
        if (res.code == 200) {
          this.addTableData = res.data.records;
          this.addPageTotal = res.data.total;
        }
      });
    },
    handleAddClear() {
      this.queryPur = {};
    },
    openDialog() {
      this.addVisible = true;
      this.queryPur = {};
      this.addTableData = [];
    },
    addScope(row) {
      const param = {};
      param.sellCompanyId = 1234;
      param.buyerCompanyId = row.buyerCompanyId;
      param.buyerCompanyName = row.buyerCompanyName;
      api.insertBuyerCompany(param).then((res) => {
        if (res.code === '200') {
          this.$message({
            showClose: true,
            message: `添加企业${row.buyerCompanyName}范围成功`,
            type: 'success',
          });
          this.addVisible = false;
          this.$refs.addDialog.getData();
        } else {
          this.$message({
            showClose: true,
            message: `添加企业${row.buyerCompanyName}范围失败`,
            type: 'error',
          });
        }
      });
    },

    updateInvoice(val) {
      console.log(val);
      const param = {};
      if (val.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择一种开票方式',
          type: 'error',
        });
      } else {
        if (val.length === 2) {
          param.invoiceModeCode = 3;
        } else {
          param.invoiceModeCode = Number(val[0]);
        }
        api.saveInvoiceMode(param).then((res) => {
          if (res.success) {
            this.$message({
              showClose: true,
              message: '开票方式修改成功',
              type: 'success',
            });
          } else {
            this.$message({
              showClose: true,
              message: '开票方式修改失败',
              type: 'error',
            });
          }
        });
      }
    },
    async getDefaultPurchaseProductSet() {
      const params = {};
      const res = await api.queryPurchaseProductRangeSet(params);
      console.log(res, 'res');
      if (res.code === '200') {
        try {
          this.radio = res.data && res.data.data ? res.data.data : '';
        } catch (error) {
          console.log(error);
        }
      }
    },
    async updateDefaultPurchaseProductSet(val) {
      const params = {
        data: val,
      };
      const res = await api.updatePurchaseProductRangeSet(params);
      if (res.code === '200') {
        this.$message({
          type: 'success',
          message: '采购商品范围设置成功!',
        });
      }
    },
    planChange(val) {
      console.log(val);
      if (val === '81') {
        this.planRadio = '82';
        this.$confirm(
          '您即将开启非计划采购功能，开启后将可直接从易派客平台选择商品加入购物车后提交订单，请确认是否继续开启？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            this.saveNotPlanPurchase(val);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
            });
          });
      }
      if (val === '82') {
        this.planRadio = '81';
        this.$confirm(
          '您即将关闭非计划采购功能，关闭后只能通过采购申请选择商品提交订单，请确认是否继续关闭？',
          '提示',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }
        )
          .then(() => {
            this.saveNotPlanPurchase(val);
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消操作',
            });
          });
      }
      // this.saveNotPlanPurchase(val)
    },
    fliterLeftTree(value, data) {
      if (!value) return true;
      return data.categoryName.indexOf(value) !== -1;
    },

    fliterRightTree(value, data) {
      if (Array.isArray(value)) {
        return value.includes(data.categoryId);
      }
      return (
        this.selectedCategory.includes(data.categoryId) &&
        data.categoryName.indexOf(value) !== -1
      );
    },

    // 所有类目
    getAllCategoryTree() {
      const params = {
        categoryId: 0,
      };
      this.treelLoading = true;
      productApi.getAllCategoryTree(params).then((res) => {
        this.treelLoading = false;
        if (res.code === '200') {
          console.log(res);
          this.leftTreeData = res.data.children;
          this.getAllData(this.leftTreeData);
          this.rightTreeData = JSON.parse(JSON.stringify(this.leftTreeData));
          this.$nextTick(() => {
            this.$refs.rightTree.filter(this.selectedCategory);
          });
        }
      });
    },
    getAllData(array) {
      if (!array) return;
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        if (element.enable != 1) {
          array.splice(index, 1);
          this.getAllData(array);
        }
        if (element.isLeaf != 1) {
          this.getAllData(element.children);
        }
      }
    },
    // 获取已选类目
    async queryPurchaseCategory() {
      const res = await productApi.queryPurchaseCategory();
      if (res.code == 200) {
        // this.selectedCategory = res.data
        this.defaultChecked = res.data;
        this.selectedCategory = res.data;
        // this.getAllCategoryTree()
      }
    },

    handleLeftTreeValue() {
      this.$refs.leftTree.filter(this.searchLeftValue);
    },
    handleRightTreeValue() {
      this.$refs.rightTree.filter(this.searchRightValue);
    },
    handleAdd() {
      // (leafOnly) 接收一个 boolean 类型的参数，若为 true 则仅返回被选中的叶子节点的 keys，默认值为 false
      const checkedArr = this.$refs.leftTree.getCheckedKeys(true);
      const newArr = [...checkedArr, ...this.selectedCategory];
      this.selectedCategory = Array.from(new Set(newArr));
      this.$nextTick(() => {
        this.$refs.rightTree.filter(this.selectedCategory);
      });
    },
    handleRemove() {
      const checkedArr = this.$refs.rightTree.getCheckedKeys(true);
      const arr = this.selectedCategory.filter(
        (item) => !checkedArr.includes(item)
      );
      this.selectedCategory = arr;
      this.$nextTick(() => {
        this.$refs.rightTree.filter(this.selectedCategory);
      });
    },
    openCategoryDialog() {
      this.categoryVisible = true;
      this.getAllCategoryTree();
    },
    async handleSubmit() {
      const params = {
        categoryIds: this.selectedCategory,
      };
      const res = await productApi.addPurchaseCategory(params);
      if (res.code == 200) {
        this.$message.success('添加成功');
        this.categoryVisible = false;
        this.queryPurchaseCategory();
      }
    },
    async queryIsOpen() {
      const res = await productApi.queryIsOpen();
      console.log(res);
      if (res.code === '200') {
        this.planIsOpen = res.data;
        if (res.data) {
          this.queryPlanPurchase();
        }
      }
    },
    // 开启关闭计划
    async saveNotPlanPurchase(val) {
      const params = {
        data: val,
      };
      const res = await userApi.saveNotPlanPurchase(params);
      if (res.code == 200) {
        this.planRadio = val;
        this.$message.success('操作成功');
      }
    },
    async queryPlanPurchase() {
      const res = await userApi.queryPlanPurchase();
      if (res.code == 200) {
        this.planRadio = res.data.data;
      }
    },
    handleCategoryCancel() {
      this.categoryVisible = false;
      this.selectedCategory = this.defaultChecked;
      this.searchLeftValue = '';
      this.searchRightValue = '';
    },
    // 交易参数配置-供应商电子发票服务启用情况
    async getElectronicInvoiceSwitch() {
      const params = {
        companyId: this.userInfo.companyId,
      };
      const info = await invoiceApi.getElectronicInvoiceSwitch(params);
      if (info.success) {
        this.electronicInvoiceSwitch = info.data.data;
      } else {
        this.$message.error('获取电子发票服务失败，请重试');
      }
    },
    // 提交修改是否开通电子发票
    async changeElectronicInvoice(e) {
      const query = {
        companyId: this.userInfo.companyId,
        data: e,
      };
      const info = await invoiceApi.updateElectronicInvoiceSwitch(query);
      if (info.success) {
        this.$message.success('修改成功');
      }
    },
    // 获得企业信息
    async getInvoiceInfo() {
      const params = {
        companyId: this.userInfo.companyId,
      };
      const info = await invoiceApi.invoiceInfo(params);
      if (info.success) {
        this.companyInvoiceInfo = info.data;
        console.log(this.companyInvoiceInfo);
        if (info.data.platformStatus === 1) {
          this.isOpenEInvoice = true;
        }
      } else {
        this.$message.error('企业信息获取失败');
      }
    },
  },
};
</script>

<style scoped lang="scss">
.manage {
  background: #fff;
  padding: 0 20px 20px 20px;
  margin-bottom: 20px;

  .manage_title {
    font-size: 14px;
    // background: #e5e5e5;
    line-height: 40px;
  }
  .switch-block {
    font-size: 14px;
    display: flex;
    align-items: center;
    .switch {
      margin-left: 10px;
      ::v-deep .el-switch__core {
        height: 16px;
        width: 33px;
      }

      ::v-deep .el-switch__core::after {
        height: 12px;
        width: 12px;
      }
    }
  }
  .yellow-tip {
    display: flex;
    background: yellow;
    padding: 10px;
    align-items: center;
    margin-top: 20px;
  }
}
.show-flex {
  display: flex;
  justify-content: start;
  align-items: center;
}

.category-management {
  display: flex;
  justify-content: space-between;

  .tree-item {
    flex: 0 0 40%;

    .title {
      background: #dcdfe6;
      height: 32px;
      line-height: 32px;
      padding: 0 10px;
      color: #333333;
      font-size: 14px;
      margin-bottom: 10px;
    }

    .tree {
      border: 1px solid #dcdfe6;
      margin-top: 10px;
      height: 340px;
      overflow-y: auto;
    }
  }

  .btn-options {
    display: flex;
    align-items: center;

    .btn {
      margin-bottom: 20px;
    }
  }

  .left-tree {
  }

  .right-tree {
  }
}

::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #333333;
}
</style>
